/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTaskLabelDto,
  DeletedResponseDto,
  TaskLabelDto,
  UpdateTaskLabelDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTaskLabelsControllerListLabelsV1Url = () => {




  return `/v1/task-labels`
}

/**
 * @summary Task labels
 */
export const taskLabelsControllerListLabelsV1 = async ( options?: RequestInit): Promise<TaskLabelDto[]> => {

  return apiRequest<TaskLabelDto[]>(getTaskLabelsControllerListLabelsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTaskLabelsControllerListLabelsV1QueryKey = () => {
    return [
    `/v1/task-labels`
    ] as const;
    }


export const getTaskLabelsControllerListLabelsV1QueryOptions = <TData = Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskLabelsControllerListLabelsV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>> = ({ signal }) => taskLabelsControllerListLabelsV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskLabelsControllerListLabelsV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>>
export type TaskLabelsControllerListLabelsV1QueryError = unknown


export function useTaskLabelsControllerListLabelsV1<TData = Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerListLabelsV1<TData = Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerListLabelsV1<TData = Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Task labels
 */

export function useTaskLabelsControllerListLabelsV1<TData = Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerListLabelsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskLabelsControllerListLabelsV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskLabelsControllerCreateLabelV1Url = () => {




  return `/v1/task-labels`
}

/**
 * @summary Create a label (owner only)
 */
export const taskLabelsControllerCreateLabelV1 = async (createTaskLabelDto: CreateTaskLabelDto, options?: RequestInit): Promise<TaskLabelDto> => {

  return apiRequest<TaskLabelDto>(getTaskLabelsControllerCreateLabelV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskLabelDto)
  }
);}





export const getTaskLabelsControllerCreateLabelV1QueryKey = (createTaskLabelDto?: CreateTaskLabelDto,) => {
    return [
    'POST', `/v1/task-labels`, createTaskLabelDto
    ] as const;
    }


export const getTaskLabelsControllerCreateLabelV1QueryOptions = <TData = Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError = unknown>(createTaskLabelDto: CreateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskLabelsControllerCreateLabelV1QueryKey(createTaskLabelDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>> = ({ signal }) => taskLabelsControllerCreateLabelV1(createTaskLabelDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskLabelsControllerCreateLabelV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>>
export type TaskLabelsControllerCreateLabelV1QueryError = unknown


export function useTaskLabelsControllerCreateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError = unknown>(
 createTaskLabelDto: CreateTaskLabelDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerCreateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError = unknown>(
 createTaskLabelDto: CreateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerCreateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError = unknown>(
 createTaskLabelDto: CreateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create a label (owner only)
 */

export function useTaskLabelsControllerCreateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError = unknown>(
 createTaskLabelDto: CreateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerCreateLabelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskLabelsControllerCreateLabelV1QueryOptions(createTaskLabelDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskLabelsControllerUpdateLabelV1Url = (id: string,) => {




  return `/v1/task-labels/${id}`
}

/**
 * @summary Rename or recolor a label (owner only)
 */
export const taskLabelsControllerUpdateLabelV1 = async (id: string,
    updateTaskLabelDto: UpdateTaskLabelDto, options?: RequestInit): Promise<TaskLabelDto> => {

  return apiRequest<TaskLabelDto>(getTaskLabelsControllerUpdateLabelV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskLabelDto)
  }
);}





export const getTaskLabelsControllerUpdateLabelV1QueryKey = (id: string,
    updateTaskLabelDto?: UpdateTaskLabelDto,) => {
    return [
    'PATCH', `/v1/task-labels/${id}`, updateTaskLabelDto
    ] as const;
    }


export const getTaskLabelsControllerUpdateLabelV1QueryOptions = <TData = Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError = unknown>(id: string,
    updateTaskLabelDto: UpdateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskLabelsControllerUpdateLabelV1QueryKey(id,updateTaskLabelDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>> = ({ signal }) => taskLabelsControllerUpdateLabelV1(id,updateTaskLabelDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskLabelsControllerUpdateLabelV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>>
export type TaskLabelsControllerUpdateLabelV1QueryError = unknown


export function useTaskLabelsControllerUpdateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError = unknown>(
 id: string,
    updateTaskLabelDto: UpdateTaskLabelDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerUpdateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError = unknown>(
 id: string,
    updateTaskLabelDto: UpdateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerUpdateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError = unknown>(
 id: string,
    updateTaskLabelDto: UpdateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Rename or recolor a label (owner only)
 */

export function useTaskLabelsControllerUpdateLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError = unknown>(
 id: string,
    updateTaskLabelDto: UpdateTaskLabelDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerUpdateLabelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskLabelsControllerUpdateLabelV1QueryOptions(id,updateTaskLabelDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTaskLabelsControllerDeleteLabelV1Url = (id: string,) => {




  return `/v1/task-labels/${id}`
}

/**
 * @summary Delete a label from every task (owner only)
 */
export const taskLabelsControllerDeleteLabelV1 = async (id: string, options?: RequestInit): Promise<DeletedResponseDto> => {

  return apiRequest<DeletedResponseDto>(getTaskLabelsControllerDeleteLabelV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTaskLabelsControllerDeleteLabelV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/task-labels/${id}`
    ] as const;
    }


export const getTaskLabelsControllerDeleteLabelV1QueryOptions = <TData = Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaskLabelsControllerDeleteLabelV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>> = ({ signal }) => taskLabelsControllerDeleteLabelV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaskLabelsControllerDeleteLabelV1QueryResult = NonNullable<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>>
export type TaskLabelsControllerDeleteLabelV1QueryError = unknown


export function useTaskLabelsControllerDeleteLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerDeleteLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>,
          TError,
          Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaskLabelsControllerDeleteLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a label from every task (owner only)
 */

export function useTaskLabelsControllerDeleteLabelV1<TData = Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taskLabelsControllerDeleteLabelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaskLabelsControllerDeleteLabelV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






